import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { createElement, Fragment } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { useRef, useEffect, useState } from '@wordpress/element';
/**
 * Internal dependencies
 */

import { Container, TopView, RightView, BottomView, LeftView } from './styles/box-control-visualizer-styles';
import { DEFAULT_VALUES, DEFAULT_VISUALIZER_VALUES } from './utils';
export default function BoxControlVisualizer(_ref) {
  var children = _ref.children,
      _ref$showValues = _ref.showValues,
      showValues = _ref$showValues === void 0 ? DEFAULT_VISUALIZER_VALUES : _ref$showValues,
      _ref$values = _ref.values,
      valuesProp = _ref$values === void 0 ? DEFAULT_VALUES : _ref$values,
      props = _objectWithoutProperties(_ref, ["children", "showValues", "values"]);

  var isPositionAbsolute = !children;
  return createElement(Container, _extends({}, props, {
    isPositionAbsolute: isPositionAbsolute,
    "aria-hidden": "true"
  }), createElement(Sides, {
    showValues: showValues,
    values: valuesProp
  }), children);
}

function Sides(_ref2) {
  var _ref2$showValues = _ref2.showValues,
      showValues = _ref2$showValues === void 0 ? DEFAULT_VISUALIZER_VALUES : _ref2$showValues,
      values = _ref2.values;
  var top = values.top,
      right = values.right,
      bottom = values.bottom,
      left = values.left;
  return createElement(Fragment, null, createElement(Top, {
    isVisible: showValues.top,
    value: top
  }), createElement(Right, {
    isVisible: showValues.right,
    value: right
  }), createElement(Bottom, {
    isVisible: showValues.bottom,
    value: bottom
  }), createElement(Left, {
    isVisible: showValues.left,
    value: left
  }));
}

function Top(_ref3) {
  var _ref3$isVisible = _ref3.isVisible,
      isVisible = _ref3$isVisible === void 0 ? false : _ref3$isVisible,
      value = _ref3.value;
  var height = value;
  var animationProps = useSideAnimation(height);
  var isActive = animationProps.isActive || isVisible;
  return createElement(TopView, {
    isActive: isActive,
    style: {
      height: height
    }
  });
}

function Right(_ref4) {
  var _ref4$isVisible = _ref4.isVisible,
      isVisible = _ref4$isVisible === void 0 ? false : _ref4$isVisible,
      value = _ref4.value;
  var width = value;
  var animationProps = useSideAnimation(width);
  var isActive = animationProps.isActive || isVisible;
  return createElement(RightView, {
    isActive: isActive,
    style: {
      width: width
    }
  });
}

function Bottom(_ref5) {
  var _ref5$isVisible = _ref5.isVisible,
      isVisible = _ref5$isVisible === void 0 ? false : _ref5$isVisible,
      value = _ref5.value;
  var height = value;
  var animationProps = useSideAnimation(height);
  var isActive = animationProps.isActive || isVisible;
  return createElement(BottomView, {
    isActive: isActive,
    style: {
      height: height
    }
  });
}

function Left(_ref6) {
  var _ref6$isVisible = _ref6.isVisible,
      isVisible = _ref6$isVisible === void 0 ? false : _ref6$isVisible,
      value = _ref6.value;
  var width = value;
  var animationProps = useSideAnimation(width);
  var isActive = animationProps.isActive || isVisible;
  return createElement(LeftView, {
    isActive: isActive,
    style: {
      width: width
    }
  });
}
/**
 * Custom hook that renders the "flash" animation whenever the value changes.
 *
 * @param {string} value Value of (box) side.
 */


function useSideAnimation(value) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  var valueRef = useRef(value);
  var timeoutRef = useRef();

  var clearTimer = function clearTimer() {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }
  };

  useEffect(function () {
    if (value !== valueRef.current) {
      setIsActive(true);
      valueRef.current = value;
      clearTimer();
      timeoutRef.current = setTimeout(function () {
        setIsActive(false);
      }, 400);
    }

    return function () {
      return clearTimer();
    };
  }, [value]);
  return {
    isActive: isActive
  };
}
//# sourceMappingURL=visualizer.js.map